import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

export default function EmployeeList() {
  const [employees, setEmployees] = useState([]);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('All');

  useEffect(() => {
    api.get('/employees').then(r => setEmployees(r.data.data)).catch(() => {});
  }, []);

  const filtered = employees.filter(e => {
    const q = search.toLowerCase();
    const matchQ = !q || `${e.first_name} ${e.last_name} ${e.employee_id} ${e.email}`.toLowerCase().includes(q);
    const matchF = filter === 'All' || e.status === filter || e.employment_type === filter;
    return matchQ && matchF;
  });

  const initials = e => `${e.first_name?.[0] || ''}${e.last_name?.[0] || ''}`.toUpperCase();
  const statusBadge = s => s === 'Active' ? 'badge-green' : s === 'Inactive' ? 'badge-amber' : 'badge-red';

  return (
    <div>
      <div className="toolbar">
        <div className="search-wrap">
          <svg fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
          <input placeholder="Search by name, ID, email…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        {['All','Active','Inactive','Intern','Permanent','Contract'].map(f => (
          <button key={f} className={`btn btn-sm ${filter === f ? 'btn-primary' : 'btn-outline'}`} onClick={() => setFilter(f)}>{f}</button>
        ))}
        <Link to="/employees/new" className="btn btn-primary" style={{marginLeft:'auto'}}>
          <svg fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M12 4v16m8-8H4"/></svg>
          Add Employee
        </Link>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Employee</th><th>ID</th><th>Designation</th><th>Department</th><th>Type</th><th>Joined</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {filtered.map(e => (
                <tr key={e.id}>
                  <td>
                    <div className="emp-name-cell">
                      <div className="emp-avatar">{initials(e)}</div>
                      <div><div style={{fontWeight:600,fontSize:13}}>{e.first_name} {e.last_name}</div><div style={{fontSize:11,color:'var(--slate-500)'}}>{e.email}</div></div>
                    </div>
                  </td>
                  <td><span className="badge badge-slate">{e.employee_id}</span></td>
                  <td style={{fontSize:13}}>{e.current_designation || '—'}</td>
                  <td style={{fontSize:13}}>{e.department || '—'}</td>
                  <td>{e.employment_type ? <span className="badge badge-indigo">{e.employment_type}</span> : '—'}</td>
                  <td style={{fontSize:12,color:'var(--slate-500)'}}>{e.joined_date ? new Date(e.joined_date).toLocaleDateString('en-GB') : '—'}</td>
                  <td><span className={`badge ${statusBadge(e.status)}`}>{e.status}</span></td>
                  <td><Link to={`/employees/${e.id}`} className="btn btn-outline btn-sm">Profile</Link></td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={8}>
                  <div className="empty-state">
                    <svg fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                    <p>No employees found.</p>
                  </div>
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
